module.exports = __webpack_public_path__ + "img/faq-mobile.ac56c562.jpg";